"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var update_params_1 = require("../update_params");
function getContextType() {
    return {
        updateUrl: PropTypes.func,
    };
}
exports.getContextType = getContextType;
var UpdateURLProvider = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateURLProvider, _super);
    function UpdateURLProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UpdateURLProvider.prototype.getChildContext = function () {
        return { updateUrl: this.props.updateUrl };
    };
    UpdateURLProvider.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    UpdateURLProvider.childContextTypes = getContextType();
    return UpdateURLProvider;
}(React.Component));
exports.UpdateURLProvider = UpdateURLProvider;
function withUpdateURL(Component) {
    var _a;
    var result = (_a = /** @class */ (function (_super) {
            tslib_1.__extends(Connected, _super);
            function Connected() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Connected.prototype.render = function () {
                var updateUrl = this.context.updateUrl || update_params_1.defaultUpdateLocation;
                return (React.createElement(Component, tslib_1.__assign({ updateUrl: updateUrl }, this.props)));
            };
            return Connected;
        }(React.Component)),
        _a.displayName = "withUpdateURL(" + (Component.displayName || Component.name) + ")",
        _a.WrappedComponent = Component,
        _a.contextTypes = getContextType(),
        _a);
    return result;
}
exports.withUpdateURL = withUpdateURL;
//# sourceMappingURL=with_update_url.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/with_update_url.js
// module id = YvhU
// module chunks = 0 1 2 3 4 9 10 14 20